import { apiClient } from '..';

interface PostArchiveReportPayload {
  backgroundTaskId: number;
  name: string;
}

export async function postArchiveReport(
  payload: PostArchiveReportPayload,
): Promise<void> {
  return apiClient<void>(`Reporting/Archive`, {
    method: 'POST',
    body: payload,
  });
}
